<template>
<div class="team_section" v-if="get_our_experts">
    <div class="container">
        <div class="team_title">
             <h2 class="t1">{{get_our_experts.title}}</h2>
        <h1 class="t2">{{get_our_experts.subtitle}}</h1>
        <p class="desc" v-html="get_our_experts.description"></p>
        </div>
        <div class="img_team">
            <img :src="get_our_experts.image" :alt="get_our_experts.title">
        </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "teamArea",
         computed:{
    ...mapGetters({
        get_our_experts:'get_our_experts',
    })
  },
    methods:{
    ...mapActions({
       our_experts_api:'our_experts_api',
    }),
    },
    mounted(){
       this.our_experts_api();
    }
}
</script>
<style lang="scss" scoped>
.team_section{
    padding-top: 100px;
.team_title{
 text-align: center;
    h1 {
      margin: 18px 0px;
    }
}
.img_team{
    margin-top: 50px;
  img{
      width: 100%;
  }
}
}
</style>